export enum ActionType {
  LINK = 'link',
  INFO_POPUP = 'info-popup',
}
